import type { ConfigRequest } from '@pba/react-utils';
import { type ApiClientResponse, type CursorPaginationRailsParams, apiClient, routes } from 'common/services';
import type { JournalNoteDataObject } from 'models/service';

export const getJournalContentObjects = async ({ config }: ConfigRequest<CursorPaginationRailsParams>) =>
  apiClient.get<JournalNoteDataObject[], ApiClientResponse<JournalNoteDataObject[]>>(routes.posts.journal, config);
